import React, { useContext } from "react";
import { storeContext } from "./global/store";
// side
import SideLayout from "./components/sideLayout";
// block
import BlockLayout from "./components/blockLayout";
import OpeningAnimatedLayer from "./components/OpeningAnimatedLayer";

const Main = () => {
  const { store } = useContext(storeContext);

  return (
    <div>
      <div className="hidden xl:grid">
        {store.layout === "side" ? (
          <SideLayout></SideLayout>
        ) : (
          <BlockLayout></BlockLayout>
        )}
        {store.triggerAnimation && (
          <OpeningAnimatedLayer></OpeningAnimatedLayer>
        )}
      </div>
      <div className="xl:hidden">
        <BlockLayout></BlockLayout>
      </div>
    </div>
  );
};

export default Main;
